import {Injectable} from '@angular/core';
import {DictionaryResolver} from './dictionary.resolver';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {catchError} from 'rxjs/operators';
import {of, throwError} from 'rxjs';
import {DictionaryService} from '../services/dictionary.service';
import {Store} from '@ngxs/store';
import {HttpErrorResponse} from '@angular/common/http';
import {AuthState} from '../state/auth/auth.state';
import {skipInterceptors} from '../helpers/request.helper';
import {User} from '../models/api/user.model';

@Injectable({providedIn: 'root'})
export class CoreDictionaryResolver extends DictionaryResolver {
    constructor(dictionaryService: DictionaryService, store: Store) {
        super(dictionaryService, store);
    }

    /**
     * NEVO-715 - allow 401 from dictionary service when user is resetting password for the first time
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
        const currentUser: User = this.store.selectSnapshot(AuthState.currentUser);
        const allowUnauthorized = this.canAllowUnauthorized(currentUser);
        return super.downloadDictionaries(route, allowUnauthorized ? skipInterceptors([401]) : undefined).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error?.status === 401 && allowUnauthorized) {
                    return of(null);
                } else {
                    return throwError(error);
                }
            })
        );
    }

    protected canAllowUnauthorized(user: User): boolean {
        return (
            user?.termsAccepted === false ||
            (user?.needsSellsTerms === true && user?.sellTermsAccepted === false) ||
            user?.passwordChangeRequired
        );
    }
}
